import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "rounded-xl border border-slate-200 bg-white p-3 transition-colors hover:border-primary-200"
};
const _hoisted_2 = {
  class: "flex flex-wrap items-center gap-1.5 text-xs"
};
const _hoisted_3 = {
  key: 0,
  class: "status-badge is-neutral"
};
const _hoisted_4 = {
  class: "status-badge is-info",
  title: "最终得分"
};
const _hoisted_5 = {
  key: 1,
  class: "status-badge is-purple",
  title: "hybrid 精排得分"
};
const _hoisted_6 = {
  class: "status-badge is-neutral"
};
const _hoisted_7 = {
  class: "text-slate-400"
};
const _hoisted_8 = {
  class: "mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-500"
};
const _hoisted_9 = {
  class: "inline-flex min-w-0 items-center gap-1"
};
const _hoisted_10 = {
  class: "truncate"
};
const _hoisted_11 = {
  class: "inline-flex min-w-0 items-center gap-1"
};
const _hoisted_12 = ["title"];
const _hoisted_13 = {
  class: "mt-2 text-sm leading-relaxed text-slate-700"
};
import { computed, ref } from 'vue';
import { highlightText } from '@/utils/textHighlight';
export default {
  __name: 'SpaceHitCard',
  props: {
    /** agent §9 命中对象（snake_case 字段） */
    hit: {
      type: Object,
      required: true
    },
    /** 高亮用查询串 */
    query: {
      type: String,
      default: ''
    },
    /** 展示序号（0 基；null 不显示） */
    index: {
      type: Number,
      default: null
    }
  },
  emits: ['preview'],
  setup(__props) {
    const props = __props;
    const expanded = ref(false);

    /** 超过 3 行左右容量才提供展开开关 */
    const collapsible = computed(() => (props.hit.text || '').length > 120);
    const highlightedHtml = computed(() => highlightText(props.hit.text || '', props.query));
    function formatScore(s) {
      return typeof s === 'number' ? s.toFixed(3) : s ?? '-';
    }
    return (_ctx, _cache) => {
      const _directive_safe_html = _resolveDirective("safe-html");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.index != null ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.index + 1), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_4, "score " + _toDisplayString(formatScore(__props.hit.score)), 1), __props.hit.rerank_score != null ? (_openBlock(), _createElementBlock("span", _hoisted_5, "rerank " + _toDisplayString(formatScore(__props.hit.rerank_score)), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_6, "chunk#" + _toDisplayString(__props.hit.chunk_no ?? '-'), 1), _createElementVNode("span", _hoisted_7, "char " + _toDisplayString(__props.hit.char_start ?? '-') + "–" + _toDisplayString(__props.hit.char_end ?? '-'), 1), _createElementVNode("button", {
        class: "ml-auto shrink-0 text-xs text-primary-600 hover:underline",
        title: "预览来源文件（PDF）",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('preview', __props.hit))
      }, "预览文件")]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, [_cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "shrink-0"
      }, "📚", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(__props.hit.space_name || `空间 ${__props.hit.space_id}`), 1)]), _createElementVNode("span", _hoisted_11, [_cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "shrink-0"
      }, "📄", -1)), _createElementVNode("span", {
        class: "truncate",
        title: __props.hit.filename
      }, _toDisplayString(__props.hit.filename || '-'), 9, _hoisted_12)])]), _createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("div", {
        class: _normalizeClass(expanded.value ? 'whitespace-pre-wrap break-words' : 'line-clamp-3')
      }, null, 2), [[_directive_safe_html, highlightedHtml.value]]), collapsible.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "mt-1 text-xs text-primary-600 hover:underline",
        onClick: _cache[1] || (_cache[1] = $event => expanded.value = !expanded.value)
      }, _toDisplayString(expanded.value ? '收起' : '展开全文'), 1)) : _createCommentVNode("", true)])]);
    };
  }
};